<!--suppress HtmlRequiredAltAttribute -->
<app-dialog *ngIf="item" class="more-details" [(visible)]="showDetails" (visibleChange)="changeVisibility()" [ngClass]="{'safari':isSafari}">
  <div *ngIf="!lotteryService.isMobile && !isTablet" class="more-info-container">
    <div class="more-info-header {{item.BackgroundColor}}">
      <h3>  {{(item.TotalTeamplayLines * 1) + (item.TotalSingleLines * 1)}} {{'bundles.lines' | translate}}</h3>
      <h5 *ngIf="showLang">{{item.DisplayNames[showLang]}}</h5>
      <img src="../../../assets/images/bundles/{{item.IconName}}/{{item.IconName}}-icon.png">
    </div>
    <div class="more-info-body">
      <table>
        <thead>
        <tr>
          <th class="lottery">Lottery</th>
          <th class="personal">{{item.TotalSingleLines}} {{'bundles.lines' | translate}} <span>{{'bundles.personal' | translate}}</span></th>
          <th class="draws">{{item.TotalSingleDraws}} {{'bundles.draws' | translate}}</th>
          <th class="syndicate">{{item.TotalTeamplayLines}} {{'bundles.lines' | translate}} <span>{{'bundles.syndicate' | translate}}</span></th>
          <th class="draws drawslast">{{item.TotalTeamplayDraws}} {{'bundles.draws' | translate}}</th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let itemDetails of item.box.details">
            <td class="lottery">
              <img src="../../../assets/images/lotteries/{{itemDetails.urlLotteryName}}/icons/{{itemDetails.urlLotteryName}}_50x50.png">
              {{itemDetails.Name}}
              <span>{{(itemDetails.teamplayTotalLines * 1) + (itemDetails.personalTotalLines * 1) }} {{'bundles.lines' | translate}}</span>
            </td>
            <td>
                {{itemDetails.personalTotalLines}}
              <span>{{'bundles.personal' | translate}} {{'bundles.lines' | translate}}</span>
            </td>
            <td>
              {{itemDetails.personalDraws}}
              <span>{{'bundles.personal' | translate}} {{'bundles.draws' | translate}}</span>
            </td>
            <td>
              {{itemDetails.teamplayTotalLines}}
              <span>{{'bundles.sharedWith' | translate}} {{itemDetails.totalShares}} {{'bundles.users' | translate}}</span>
            </td>
            <td>
              {{itemDetails.teamplayDraws}}
              <span>{{'bundles.sharedWith' | translate}} {{itemDetails.totalShares}} {{'bundles.users' | translate}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="more-info-sum-up">
        <span class="total">{{(item.TotalTeamplayLines * 1) + (item.TotalSingleLines * 1)}} {{'scratchcards.tickets' | translate }}</span>

        <span class="duration" *ngIf="item.Duration && !item.Draws">
          <span *ngIf="item.Duration === '1'">{{item.Duration}} {{ 'static.week' | translate}}</span>
                  <span *ngIf="item.Duration !== '1'">{{item.Duration}} {{ 'bundles.weeks' | translate}}</span>
        </span>
        <span class="duration" *ngIf="!item.Duration && item.Draws">
          <span *ngIf="item.Draws === '1'">{{item.Draws}} {{ 'cart.products.draw' | translate}}</span>
                  <span *ngIf="item.Draws !== '1'">{{item.Draws}} {{ 'bundles.draws' | translate}}</span>
        </span>
        <span id="{{item.Name | lowercase}}-bundle-play-more-info" class="bundle-button przycisk green big" [ngClass]="{'disabled-btn' : isLoadingButton }" (click)="buyPackage(item.PackageID)">{{ 'bundles.getIt'| translate}} {{item.Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}} <span *ngIf="isLoadingButton" class="spinner"></span></span>
      </div>
    </div>
  </div>
  <div *ngIf="lotteryService.isMobile || isTablet" class="mobile-bundle-wrapper more-info-container">
    <div class="more-info-header {{item.BackgroundColor}}">
      <h3>  {{(item.TotalTeamplayLines * 1) + (item.TotalSingleLines * 1)}} {{'bundles.lines' | translate}}</h3>
      <h5> {{item.DisplayName}}</h5>
      <img src="../../../assets/images/bundles/{{item.IconName}}/{{item.IconName}}-icon.png">
    </div>
    <div class="bundle-wrap">
      <div class="lottery">Lottery</div>
        <mat-accordion>
          <mat-expansion-panel *ngFor="let item of item.box.details">
            <mat-expansion-panel-header class="accordionBg">
              <img src="../../../assets/images/lotteries/{{item.urlLotteryName}}/icons/{{item.urlLotteryName}}_40x40.png">
              <span class="lottery-name">{{item.Name}}</span>
              <span class="lines">{{item.personalTotalLines + item.teamplayTotalLines}} {{'bundles.lines' | translate}}</span>
            </mat-expansion-panel-header>
              <div class="personal-container">
                <div class="personal">{{'bundles.personal' | translate }}</div>
                <div class="lines">{{'bundles.lines' | translate}}</div>
                <div class="no-text">
                  {{item.personalTotalLines}} <span>{{'bundles.personal' | translate}} {{'bundles.lines' | translate}}</span>
                </div>
                <div class="draws"> {{'bundles.draws' | translate}}</div>
                <div class="no-text">
                  {{item.personalDraws}}
                  <span>{{'bundles.personal' | translate}} {{'bundles.draws' | translate}}</span>
                </div>
              </div>
            <div class="syndicate-container">
              <div class="syndicate">{{'bundles.syndicate' |translate}}</div>
              <div class="lines">{{'bundles.lines' | translate}}</div>
              <div class="no-text">
                {{item.teamplayTotalLines}}
                <span>{{'bundles.sharedWith' | translate}} {{item.totalShares}} {{'bundles.users' | translate}}</span>
              </div>
              <div class="draws drawslast"> {{'bundles.draws' | translate}}</div>
              <div class="no-text">
              {{item.teamplayDraws}}
                <span>{{'bundles.sharedWith' | translate}} {{item.totalShares}} {{'bundles.users' | translate}}</span>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
          <div class="more-info-sum-up">
            <div class="more-info-body">
            <div class="info">
              <span class="total">{{(item.TotalTeamplayLines * 1) + (item.TotalSingleLines * 1)}} <span>{{'scratchcards.tickets' | translate }} </span></span>

              <span class="duration" *ngIf="item.Duration && !item.Draws">
                {{item.Duration}}  <span>{{ 'bundles.weekss' | translate}}</span>
              </span>
              <span class="duration" *ngIf="!item.Duration && item.Draws">
                {{item.Draws}} <span> {{ 'bundles.draws' | translate}}</span>
              </span>

            </div>
            <div *ngIf="item && item.Rates && item.Rates.OnlinePrice[currency.Code]" id="{{item.Name | lowercase}}-bundle-play" class="button-to-cart">
              <span class="bundle-button przycisk green big" [ngClass]="{'disabled-btn' : isLoadingButton }" (click)="buyPackage(item.PackageID)">{{'bundles.getIt'|translate}} {{item.Rates.OnlinePrice[currency.Code] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}} <span *ngIf="isLoadingButton" class="spinner"></span></span>
            </div>
          </div>
        </div>
      </div>
  </div>
</app-dialog>

